import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetUsersQuery } from '../redux/reducers/usersSlice'
import RoleType from '../types/enums/RoleType'
import { useGetDictionariesQuery, useGetNestedDictionaryQuery } from '../redux/reducers/dictionarySlice'
import DecisionEnum from '../types/enums/DecisionEnum'

export const useRecruitmentWorkflow = (watchedStage?: string) => {
  const { t } = useTranslation()

  const { data: managementAndRecruiters } = useGetUsersQuery({
    page: 0,
    size: 20,
    'roles.name': [RoleType.Management, RoleType.Recruiter].toString(),
  })

  const { data: stagesResponse } = useGetDictionariesQuery({
    page: 0,
    size: 20,
    group: 'RECRUITMENT_WORKFLOW',
    sortField: 'order',
  })

  const { data: nestedResponse } = useGetNestedDictionaryQuery('RECRUITMENT_WORKFLOW')

  const stageOptions =
    stagesResponse?.content.map(stage => ({
      label: stage.value,
      value: stage.id,
    })) ?? []

  const stepOptions = useMemo(() => {
    const stage = stagesResponse?.content.find(stage => stage.id === watchedStage)
    if (stage) {
      const steps = nestedResponse?.nestedDictionary[stage.key]
      if (steps) {
        return Object.values(steps).map(step => ({
          label: step.value,
          value: step.id,
        }))
      }
    }
    return []
  }, [nestedResponse, watchedStage, stagesResponse?.content])

  const decisionOptions = [
    { label: t('decision.waiting'), value: DecisionEnum.WAITING },
    { label: t('decision.accepted'), value: DecisionEnum.ACCEPTED },
    { label: t('decision.rejected'), value: DecisionEnum.REJECTED },
  ]

  return {
    managementAndRecruiters,
    stageOptions,
    stepOptions,
    decisionOptions,
  }
}